export default __webpack_public_path__ + "static/media/editing-control.54466fa4.svg";